import { useState, type MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useAuthStore } from '../auth/authStore';

/** Renk modu geçişi — MUI `useColorScheme` `localStorage` (`tfw:color-mode`) ile
 *  kalıcılığı kendi yönetir. `mode` ilk render'da `undefined` olabilir (hydration);
 *  o durumda 'light' varsay. */
function useColorModeToggle() {
  const { mode, setMode } = useColorScheme();
  const isDark = mode === 'dark';
  const toggle = () => setMode(isDark ? 'light' : 'dark');
  return { isDark, toggle };
}

export function Topbar() {
  const navigate = useNavigate();
  const currentUser = useAuthStore((s) => s.currentUser);
  const logout = useAuthStore((s) => s.logout);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { isDark, toggle } = useColorModeToggle();

  const handleOpen = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogout = () => {
    handleClose();
    logout();
    navigate('/login', { replace: true });
  };

  const displayName = currentUser?.userName ?? currentUser?.gsaName ?? 'Kullanıcı';

  return (
    <AppBar position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
      <Toolbar>
        <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
          TravelFuture
        </Typography>
        <Tooltip title={isDark ? 'Açık temaya geç' : 'Koyu temaya geç'}>
          <IconButton onClick={toggle} color="inherit" size="small" aria-label={isDark ? 'Açık tema' : 'Koyu tema'}>
            {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
        <Box sx={{ ml: 1 }}>
          <IconButton onClick={handleOpen} color="inherit" size="small">
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'secondary.main' }}>
              {displayName.charAt(0).toUpperCase()}
            </Avatar>
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem disabled>{displayName}</MenuItem>
            <MenuItem
              onClick={() => {
                toggle();
                handleClose();
              }}
            >
              <ListItemIcon>
                {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
              </ListItemIcon>
              {isDark ? 'Açık tema' : 'Koyu tema'}
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              Çıkış
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
